import React, { useEffect, useRef, useState } from "react";
import { Chart, CategoryScale, LinearScale, BarElement, Title } from "chart.js";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  nbfPriceTypeByDates,
  nbfSub_TypePriceByDates,
} from "../../api/restApi";
Chart.register(CategoryScale, LinearScale, BarElement, Title);

export default function DashboardProducts() {
  const [selectedRange, setSelectedRange] = useState([null, null]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCategory, setSubCategory] = useState();
  const [categoryPrice, setCategoryPrice] = useState();
  const [labels, setLabels] = useState();
  const [data, setData] = useState();
  const chartRef = useRef(null);
  const onChange = (value) => {
    setSelectedRange(value);
  };
  const formattedDateRange = selectedRange?.map((val) => {
    return val?.toISOString().substring(0, 10);
  });
  console.log(formattedDateRange);

  const handleSelectCagegory = async (event, newValue) => {

    
    console.log(newValue);
    setSelectedCategory(newValue);
  };

  useEffect(() => {
    let processData = async () => {
      try {
        let mydata = await nbfPriceTypeByDates(
          formattedDateRange[0],
          formattedDateRange[1]
        );
        console.log(mydata);
        let subCatData = await nbfSub_TypePriceByDates(  formattedDateRange[0],formattedDateRange[1],selectedCategory)
        console.log(subCatData)
        const subCatNames = subCatData.map(item => item.name);
        console.log(subCatNames);
        setSubCategory(subCatNames)
        const subCatPrice = subCatData.map(item => item.price);
        setCategoryPrice(subCatPrice)
        const incomingLabels = mydata.map((item) => Object.keys(item)[0]);
        console.log(incomingLabels);
        setLabels(incomingLabels);
        

        const incomingData = mydata.map((item) => Object.values(item)[0]);
        console.log(incomingData);
        setData(incomingData);
      } catch (error) {
        console.log(error);
      }
    };
  
    processData();
  }, [selectedRange, selectedCategory]);
  

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      let chartInstance;

      const createChart = () => {
        chartInstance = new Chart(ctx, {
          type: "bar",
          data: {
            labels: selectedCategory? subCategory: labels,
            datasets: [
              {
                label: "# of Votes",
                data: selectedCategory?categoryPrice: data,
                borderWidth: 1,
              },
            ],
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          },
        });
      };

      createChart();

      return () => {
        if (chartInstance) {
          chartInstance.destroy();
        }
      };
    }
  }, [labels, data]);



  return (
    <div>
      {/* <DateRangePicker
        onChange={onChange}
        value={selectedRange}
        maxDate={new Date(Date.now() + 1)}
      />
      <Autocomplete
          disablePortal
          id="combo-box-demo2"
          options={labels}
          sx={{
            minWidth: 300,
            display: "flex",
            justifyContent: "center",
          }}
          value={selectedCategory}
          onChange={handleSelectCagegory}
          renderInput={(params) => (
            <TextField {...params} label="Select Category" />
          )}
        />
{selectedRange && data && labels &&
      <canvas ref={chartRef} id="myChart"></canvas>
} */}
      
    </div>
  );
}
